/* import __COLOCATED_TEMPLATE__ from './time-picker.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { convertTimeStringToLocalizedFormat } from '@dashboard/shared-ui/utils/availability/availability-period-utils';
import { inject as service } from '@ember/service';
import { START_TIME_DEFAULT_VALUE, END_TIME_DEFAULT_VALUE } from '@square/dashboard-items-data/models/connect/availability-period/data';
import range from '@square/dashboard-utilities/utils/math/range';
/**
 * This is an IIFE that allows us to cache options in the closure of the outer function
 * This allows us to avoid having to generate options each time this function is called.
 */
export const generateTimePickerOptions = function () {
  let cachedOptions = [];
  let cachedLangCode = '';
  return function (languageCode) {
    if (languageCode !== cachedLangCode) {
      // Clear the cached options in case they've already been generated
      cachedOptions = [];
      cachedLangCode = languageCode;
      const Hours = range(24).map(hour => String(hour).padStart(2, '0')); // ["00", "01", "02", "03" ... "23"]
      const Minutes = ['00', '15', '30', '45']; // 15 minute increments

      for (const hour of Hours) {
        for (const minute of Minutes) {
          const value = `${hour}:${minute}:00`;
          cachedOptions.push({
            label: convertTimeStringToLocalizedFormat(languageCode, value),
            value
          });
        }
      }
    }
    return cachedOptions;
  };
}();
let TimePicker = (_class = class TimePicker extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get options() {
    return generateTimePickerOptions(this.intl.primaryLocale);
  }
  get defaultOption() {
    const defaultTime = this.args.defaultLocalTime ?? (this.args.isStart ? START_TIME_DEFAULT_VALUE : END_TIME_DEFAULT_VALUE);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.options.find(option => option.value === defaultTime);
  }
  get currentOption() {
    if (!this.args.selectedTime) {
      return this.defaultOption;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return this.options.find(option => option.value === this.args.selectedTime);
  }
  get placeholderText() {
    if (this.args.isStart) {
      return this.intl.t('sharedUi.availability.period.placeholder.startTime');
    }
    return this.intl.t('sharedUi.availability.period.placeholder.endTime');
  }
  timeChanged(newOption) {
    this.args.onTimeChange({
      value: newOption.value,
      isStart: this.args.isStart
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "timeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "timeChanged"), _class.prototype), _class);
export { TimePicker as default };